module.exports = __webpack_public_path__ + "img/eyes_female_asian_thin.a05d8256.png";